import { createContext } from "react";

import type { AudioPlayerContextValue } from "./audioPlayerTypes";

export const AudioPlayerContext = createContext<
  AudioPlayerContextValue | undefined
>(undefined);
